import React, { Component } from 'react'
 
import { CSVReader } from 'react-papaparse'
import AddTitleBar from '../../titleBar/add_titleBar'
import { Button, Segment } from 'semantic-ui-react'

const buttonRef = React.createRef()
 
export default class ImportVehicle extends Component {
  handleOpenDialog = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e)
    }
  }
 
  handleOnFileLoad = (data) => {
    console.log(data)
  }
 
  handleOnError = (err, file, inputElem, reason) => {
    console.log(err)
  }
 
  handleOnRemoveFile = (data) => {
    console.log(data)
  }
 
  handleRemoveFile = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e)
    }
  }
 
  render() {
    return (
        <>
            <AddTitleBar Title="Import Vehicle" LinkName="/vehicle" />
            <CSVReader
                ref={buttonRef}
                onFileLoad={this.handleOnFileLoad}
                onError={this.handleOnError}
                noClick
                noDrag
                onRemoveFile={this.handleOnRemoveFile}
            >
                {({ file }) => (
                <Segment>
                    <Button
                    type='button'
                    onClick={this.handleOpenDialog}
                    size="tiny"
                    >
                    Browe file
                    </Button>
                    <div>
                    {file && file.name}
                    </div>
                    <Button
                    size="tiny"
                    onClick={this.handleRemoveFile}
                    >
                    Remove
                    </Button>
                </Segment>
                )}
            </CSVReader>
        </>
    )
  }
}
